export const getSelectedUser = (state) => state.adminUser.selectedUser
